import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import TabsContext from '../context/tabs-context';
import TabContent from '../components/tab-content';

const TabContentContainer = ({ tabId, children }) => {
  const {
    activeTabId,
    skipRenderInactiveContent,
    disableSwipeableContent,
    scrollContainerRef,
    noSideSpacing,
    noVerticalSpacing,
    noOverflow,
  } = useContext(TabsContext);
  const isActive = activeTabId === tabId;
  const isHidden = !isActive && disableSwipeableContent;
  const shouldNotRenderTab = skipRenderInactiveContent && isHidden;

  if (shouldNotRenderTab) {
    return null;
  }

  return (
    <TabContent
      hidden={isHidden}
      noSideSpacing={noSideSpacing}
      noVerticalSpacing={noVerticalSpacing}
      noOverflow={noOverflow}
      {...(isActive && { ref: scrollContainerRef })}
    >
      {children}
    </TabContent>
  );
};

TabContentContainer.propTypes = {
  tabId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default TabContentContainer;
